export const documentTipsModalStyles = {
  paper: {
    margin: 0,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    overflow: 'visible',
    borderRadius: '16px 16px 0 0',
    maxWidth: '100%',
    width: '100%',
  },
  container: {
    display: 'flex',
    padding: '16px 16px 24px 16px',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
    borderRadius: '16px 16px 0 0',
    background: 'var(--color-surface-card)',
    boxShadow: '0 4px 6px 0 rgba(11, 18, 32, 0.05), 0 8px 16px 0 rgba(11, 18, 32, 0.10)',
  },
  dragHandleRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    mb: '-4px',
  },
  dragHandle: {
    width: 40,
    height: 6,
    borderRadius: '99px',
    backgroundColor: '#CBD2DB',
  },
  header: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start',
    width: '100%',
  },
  titleWrap: {
    flex: '1 0 0',
    minWidth: 0,
  },
  title: {
    alignSelf: 'stretch',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'Noto Sans',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '28px', 
    letterSpacing: '-0.2px',
  },
  floatingCloseButton: {
    position: 'absolute',
    top: '-48px',
    right: '10px',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#E5E7EB',
    boxShadow: '0 4px 12px rgba(11, 18, 32, 0.18)',
    p: 0,
    '&:hover': {
      backgroundColor: '#DDE1E7',
    },
  },
  exampleBox: {
    display: 'flex',
    padding: '12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '12px',
    border: '0.705px solid #EAEEF4',
    background: '#EAEEF4',
    width: '100%',
  },
  exampleTitle: {
    alignSelf: 'stretch',
    color: '#31373F',
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.15px',
  },
  bullets: {
    mt: 0,
    mb: 0,
    pl: '24px',
    pr: 1,
    width: '100%',
  },
  bulletItem: {
    display: 'revert',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1 0 0',
    alignSelf: 'stretch',
    color: '#0B1220',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.15px',
    mb: 0.5,
  },
  gotItButton: {
    mt: '8px',
    height: '52px',
    borderRadius: '10px',
    textTransform: 'none',
    fontFamily: 'Noto Sans',
    fontWeight: 600,
    fontSize: '18px',
    backgroundColor: '#2A72C4',
    '&:hover': { backgroundColor: '#1F64B1' },
  },
};

export const documentTipsIllustrationStyles = {
  root: {
    backgroundColor: '#000',
    borderRadius: '4px',
    width: '100%',
    aspectRatio: '2.1 / 1',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'none',
    display: 'block',
  },
  cornerTopLeft: {
    position: 'absolute',
    left: 14,
    top: 14,
    width: 34,
    height: 34,
    borderLeft: '6px solid #f62d67',
    borderTop: '6px solid #f62d67',
  },
  cornerTopRight: {
    position: 'absolute',
    right: 14,
    top: 14,
    width: 34,
    height: 34,
    borderRight: '6px solid #f62d67',
    borderTop: '6px solid #f62d67',
  },
  cornerBottomLeft: {
    position: 'absolute',
    left: 14,
    bottom: 14,
    width: 34,
    height: 34,
    borderLeft: '6px solid #f62d67',
    borderBottom: '6px solid #f62d67',
  },
  cornerBottomRight: {
    position: 'absolute',
    right: 14,
    bottom: 14,
    width: 34,
    height: 34,
    borderRight: '6px solid #f62d67',
    borderBottom: '6px solid #f62d67',
  },
};
